/** @module csi/action/ImageWhereUsed */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/reflection",
], function(declare, lang, Action, ViewRef, reflection) {

	return declare(Action, {
		classController: "csi.action.PopupController",
		classControllerParams: {
			popupForceBrowse: true,
			popupLinkTarget: "_blank"
		},
		m_id: "ImageWhereUsed",

		/**
		 * Check access to action based on given context
		 * @param {Context} ctx
		 * @return {boolean}
		 */
		hasAccess: function(ctx) {
			return (ctx.getNodeType() == reflection.TYPE_IMAGE) || this.m_viewRef.m_url;
		},

		/**
		 * Perform initialization, assign image node cnl and use count for the image
		 * @param {string} url - cnl of image node
		 * @return {ImageWhereUsed} - return self 
		 */
		init: function(url) {
			this.m_viewRef = lang.mixin(new ViewRef(), {
				m_id: "ImageWhereUsed",
				m_url: url
			});
			this.resolve();
			return this;
		},
	});
});